// This is the polyfill for Array.prototype.at() that is in the chess.js library.
if (!Array.prototype.at) {
    Array.prototype.at = function (index: number) {
        const normalizedIndex = index < 0 ? this.length + index : index;
        return this[normalizedIndex] ?? undefined;
    };
}
